"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "McpPostOperations", {
    enumerable: true,
    get: function() {
        return McpPostOperations;
    }
});
const _common = require("@nestjs/common");
const _mcpservice = require("~/services/mcp.service");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let McpPostOperations = class McpPostOperations {
    async handle(context, { payload, req, operation }) {
        switch(operation){
            case 'mcpCreate':
                return await this.mcpService.create(context, payload, req);
            case 'mcpUpdate':
                return await this.mcpService.regenerateToken(context, payload.tokenId, payload, req);
            case 'mcpDelete':
                return await this.mcpService.delete(context, payload.tokenId, req);
        }
    }
    constructor(mcpService){
        this.mcpService = mcpService;
        this.operations = [
            'mcpCreate',
            'mcpUpdate',
            'mcpDelete'
        ];
        this.httpMethod = 'POST';
    }
};
McpPostOperations = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _mcpservice.McpTokenService === "undefined" ? Object : _mcpservice.McpTokenService
    ])
], McpPostOperations);
